module.exports = __webpack_public_path__ + "img/illust-oba-play.18eaf5f2.gif";